import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import NodeContentQueryEn from '../QueriesEn/NodeContentQueryEn';
import NodeContentQueryHi from '../QueriesHi/NodeContentQueryHi';

const PageDataFetcher = ({ setPageNodeData, currentLanguage }) => {
  const nodeContentQuery = currentLanguage === 'en' ? NodeContentQueryEn : NodeContentQueryHi;

  const {  data } = useQuery(nodeContentQuery, {
    fetchPolicy: 'network-only',
    variables: { language: currentLanguage },
  });

  useEffect(() => {
    if (data) {
      const nodes = data.nodePages.nodes;
      setPageNodeData(nodes);
      // console.log('Fetched nodes data:', nodes);
    }
  }, [data, setPageNodeData]);

  return null;
};

export default PageDataFetcher;
